import React, {Component} from 'react'
import Navbar from './Navbar';
import Footer from './Footer';

class CustomSolutions extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className='faq-grid-layout'>
               <Navbar />
               <div className='top-spacer' />
               <div className='banner'>
                    <div className='banner-container'>
                        <h1>Custom Solutions</h1>
                    </div>
               </div>
               <div className='mainsection'>
                    <div className='main-container'>
                        <p>
                            <h1>Ready to Embark on Your AI Journey? Custom Software Solutions for Intelligent Knowledge Management</h1>
                        </p>
                        <p>
                            <h3>Unlock the Full Potential of Your Private Knowledge Assets</h3>
                        </p>
                        
                        <p>
                            We design and develop bespoke AI-powered software that transforms the way organisations manage, access and utilise their internal knowledge.
                            <i>
                            Whether you need a secure private knowledge base, intelligent search capability, or seamless AI-powered information retrieval, we build tailored solutions that empower your team, streamline workflows, and safeguard institutional expertise.
                            </i>
                        </p>
                        <h1>Flexible Deployment: Cloud or On-Premises</h1>
                        <p>
                            Your data. Your rules. We offer deployment options tailored to your security and operational needs: 
                        </p>
                        <ul>
                            <li>
                                <strong>Cloud-based solutions: </strong>Scalable, cost-effective, and accessible from anywhere
                            </li>
                            <li>
                                <strong>Locally hosted systems: </strong>Complete data control with on-premises infrastructure
                            </li>
                        </ul>
                        <h1>Private Knowledge Bases & Secure Repositories</h1>
                        <p>Turn scattered information into a centralised, intelligent hub where critical knowledge is preserved and easily accessible:</p>
                        <ul>
                            <li>
                                Proprietary research & technical documentation                            
                            </li>
                            <li>
                                Internal processes, best practices and SOPs
                            </li>
                            <li>
                                Employee expertise & institutional knowledge
                            </li>
                        </ul>
                        <h1>AI-Powered Intelligence for Smarter Workflows</h1>
                        <p>Enhance knowledge retrieval and decision-making with advanced AI capabilities:</p>
                        <ul>
                            <li>
                                <strong>Natural Language Processing (NLP): </strong>Chat with your data 
                            </li>
                            <li>
                                <strong>Deep Learning Insights: </strong>Personalised recommendations and predictions based on your workflows 
                            </li>
                            <li>
                                <strong>Intelligent Search: </strong>Find relevant information effortlessly with smart indexing 
                            </li>
                            <li>
                                <strong>Automate Categorisation: </strong>AI-driven tagging and metadata generation for seamless organisation
                            </li>
                        </ul>
                        <br />
                        <h4>Why Choose Our Custom AI Solutions?</h4>
                        <ul>
                            <li><strong>✅ Faster, More Informed Decisions: </strong>No more wasted time searching for information</li>
                            <li><strong>✅ Seamless Collaboration: </strong>Enable knowledge-sharing across teams & departments</li>
                            <li><strong>✅ Institutional Knowledge Retention: </strong>Preserve critical expertise, even as teams evolve</li>
                            <li><strong>✅ Increased Productivity: </strong>Reduce bottlenecks with AI-driven automation & organisation
                            Transform the way your organisation accesses and utilises knowledge. Contact us today to explore how our custom AI software solutions can empower your team with intelligent, secure, and efficient information management.
                            </li>
                        </ul>
                        <br />
                        <h1>Free AI-Powered Renaming Script for Smarter File Management</h1>
                        <p>Managing large volumes of files shouldn’t be a hassle. That’s why we’re offering our renaming script - 100% free. 
                        </p>
                        <p>
                            Designed for organisation that need efficient, intelligence and privacy-first file organisation, this script works within your own infrastructure, ensuring full control over your data. 
                        </p>
                        <strong>Why Use Our Free Renaming Script? </strong>
                        <ul>
                            <li><strong>✅ Streamline Final Project Documentation: </strong>Automatically organise and rename final project files for consistency and easy retrieval</li>
                            <li><strong>✅ Context-Aware Renaming: </strong>Uses AI to generate relevant and structured file names based on content and metadata</li>
                            <li><strong>✅ Enhanced Searchability: </strong>Integrates metadata to make internal documents more accessible and discoverable</li>
                        </ul>
                        <strong>How It Works</strong>
                        <ul>
                            <li>1. <strong>Request the Script: </strong>Reach out, and we’ll send it to you—free of charge.</li>
                            <li>2. <strong>Deploy It Securely: </strong>Run the script in your own environment, using your AI capabilities.</li>
                            <li>3. <strong>Automate & Optimise: </strong>Files are renamed intelligently, improving searchability and organisation.</li>
                            <li>4. <strong>Maintain Total Privacy: </strong>All processing happens within your system—your data stays yours.</li>
                        </ul>
                        <br />
                        <h4>Who Can Benefit?</h4>
                        <ul>
                            <li>🔹 Organisations with <strong>existing AI capabilities </strong>looking to optimise file management</li>
                            <li>🔹 Teams dealing with <strong>large file volumes </strong>that require structured naming</li>
                            <li>🔹 Businesses with <strong>strict privacy and security policies </strong>needing full control over their data</li>
                        </ul>

                        <p>
                            <strong>Smart. Secure. Private. And always free.</strong>
                        </p>
                        <br />
                        <h1>Take Back Your Time—Streamline Your E&S Risk Management</h1>
                        <p>
                            Optimise your Environmental and Social risk management with AI-powered solutions designed for efficiency and impact. <strong>Get in touch today </strong>to explore how our cutting-edge tools, expert consulting, and tailored development services can transform your workflows.
                        </p>
                    </div>
               </div>
               <Footer />
            </div>
        )
    }
}

export default CustomSolutions